import { useState, useEffect, type JSX } from "react";
import AppRouter from "./Router";
import SplashScreen from "./components/common/SplashScreen"; // ✅ Import the splash screen

function App(): JSX.Element {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Reduced splash to 500ms to minimize LCP delay (was causing 3100ms element render delay)
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="app w-100">
      {isLoading ? <SplashScreen /> : <AppRouter />}
    </div>
  );
}

export default App;
